export default __webpack_public_path__ + "static/media/IosQR.c44023e7.png";